import PreviewPanel from "./functional";
export default PreviewPanel;
